// src/client/game/core/levels/Level.ts

export type LevelId = number; // 1..10

export interface LevelConfig {
  id: LevelId;
  label: string;
  targetScore: number;
  blurb: string;
}

/** Domain object: a single level definition (no runtime wiring yet). */
export class Level {
  constructor(public readonly config: LevelConfig) {}

  get id(): LevelId {
    return this.config.id;
  }

  get label(): string {
    return this.config.label;
  }

  get targetScore(): number {
    return this.config.targetScore;
  }

  get blurb(): string {
    return this.config.blurb;
  }
}
